// http://ross.posterous.com/2008/08/19/iphone-touch-events-in-javascript/
svgedit.touchHandler = function (event) {
  'use strict';
  event = event.originalEvent ? event.originalEvent : event;

  const touches = event.changedTouches;
  const first = touches[0];
  let type = '';

  let canvas = null;

  if (INKIVE && INKIVE.Tool)	{
    canvas = INKIVE.Tool.getInstance().editor.canvas;
  }

  switch (event.type) {
    case 'touchstart': type = 'mousedown'; break;
    case 'touchmove': type = 'mousemove'; break;
    case 'touchend': type = 'mouseup'; break;
    default: return;
  }

  // touches.length - only for the first touch
  if (touches.length < 2)	{
    let simulatedEvent = document.createEvent('MouseEvent');
    simulatedEvent.initMouseEvent(type, true, true, window, 1,
      first.screenX, first.screenY,
      first.clientX, first.clientY, false,
      false, false, false, 0/* left */, null);

    first.target.dispatchEvent(simulatedEvent);
    if (event.type == 'touchend') {
      type = 'click';
      simulatedEvent = document.createEvent('MouseEvent');
      simulatedEvent.initMouseEvent(type, true, true, window, 1,
        first.screenX, first.screenY,
        first.clientX, first.clientY, false,
        false, false, false, 0/* left */, null);
      first.target.dispatchEvent(simulatedEvent);
    }
    event.preventDefault();
  }
};
